import { get, put, post, del } from '../../../actions'

export const GET_DATASOURCES_REQUEST = '@@datasources/GET_DATASOURCES_REQUEST'
export const GET_DATASOURCES_SUCCESS = '@@datasources/GET_DATASOURCES_SUCCESS'
export const GET_DATASOURCES_FAILURE = '@@datasources/GET_DATASOURCES_FAILURE'
export const getDatasources = (endpoint) => (
    get({
        displayName: 'get datasources',
        endpoint: endpoint,
        types: [
            GET_DATASOURCES_REQUEST, 
            GET_DATASOURCES_SUCCESS, 
            GET_DATASOURCES_FAILURE]
    })
)

export const GET_DATASOURCE_REQUEST = '@@datasources/GET_DATASOURCE_REQUEST'
export const GET_DATASOURCE_SUCCESS = '@@datasources/GET_DATASOURCE_SUCCESS'
export const GET_DATASOURCE_FAILURE = '@@datasources/GET_DATASOURCE_FAILURE'
export const getDatasource = ( datasource ) => (
    get({
        displayName: 'get datasource',
        endpoint: datasource,
        types: [
            GET_DATASOURCE_REQUEST,
            GET_DATASOURCE_SUCCESS,
            GET_DATASOURCE_FAILURE]
    })
)

export const GET_DATASOURCE_META_DATA_REQUEST = '@@datasources/GET_DATASOURCE_META_DATA_REQUEST'
export const GET_DATASOURCE_META_DATA_SUCCESS = '@@datasources/GET_DATASOURCE_META_DATA_SUCCESS'
export const GET_DATASOURCE_META_DATA_FAILURE = '@@datasources/GET_DATASOURCE_META_DATA_FAILURE'
export const getDatasourceMetadata = ( location ) => (
    get({
        displayName: 'get datasource metadata',
        endpoint: location,
        types: [
            GET_DATASOURCE_META_DATA_REQUEST,
            GET_DATASOURCE_META_DATA_SUCCESS,
            GET_DATASOURCE_META_DATA_FAILURE]
    })
)

export const GET_DATASOURCE_OBJECTS_REQUEST = '@@datasources/GET_DATASOURCE_OBJECTS_REQUEST'
export const GET_DATASOURCE_OBJECTS_SUCCESS = '@@datasources/GET_DATASOURCE_OBJECTS_SUCCESS'
export const GET_DATASOURCE_OBJECTS_FAILURE = '@@datasources/GET_DATASOURCE_OBJECTS_FAILURE'
export const getDatasourceObjects = ( location, count ) => (
    get({
        displayName: 'get datasource objects',
        endpoint: location + '/' + count,
        types: [
            GET_DATASOURCE_OBJECTS_REQUEST,
            GET_DATASOURCE_OBJECTS_SUCCESS,
            GET_DATASOURCE_OBJECTS_FAILURE]
    })
)

export const UPDATE_DATASOURCE_REQUEST = '@@datasources/UPDATE_DATASOURCE_REQUEST'
export const UPDATE_DATASOURCE_SUCCESS = '@@datasources/UPDATE_DATASOURCE_SUCCESS'
export const UPDATE_DATASOURCE_FAILURE = '@@datasources/UPDATE_DATASOURCE_FAILURE'
export const updateDatasource = ( datasource, body ) =>(
    put({
        displayName: 'update datasource',
        endpoint: datasource,
        types: [
            UPDATE_DATASOURCE_REQUEST,
            UPDATE_DATASOURCE_SUCCESS,
            UPDATE_DATASOURCE_FAILURE],
        body: JSON.stringify(body)
    })
)


export const DELETE_DATASOURCE_REQUEST = '@@datasources/DELETE_DATASOURCE_REQUEST'
export const DELETE_DATASOURCE_SUCCESS = '@@datasources/DELETE_DATASOURCE_SUCCESS'
export const DELETE_DATASOURCE_FAILURE = '@@datasources/DELETE_DATASOURCE_FAILURE'
export const deleteDatasource = ( solution, deleteData ) => (
    del({
        displayName: 'delete datasource',
        endpoint: solution,
        types: [
            DELETE_DATASOURCE_REQUEST,
            DELETE_DATASOURCE_SUCCESS,
            DELETE_DATASOURCE_FAILURE],
        body: JSON.stringify({
         deleteData : deleteData})
    })
)


export const GET_BUCKETS_REQUEST = '@@datasources/GET_BUCKETS_REQUEST'
export const GET_BUCKETS_SUCCESS = '@@datasources/GET_BUCKETS_SUCCESS'
export const GET_BUCKETS_FAILURE = '@@datasources/GET_BUCKETS_FAILURE'
export const getBuckets = (endpoint) => (
    get({
        displayName: 'get buckets',
        endpoint: endpoint,
        types: [
            GET_BUCKETS_REQUEST, 
            GET_BUCKETS_SUCCESS, 
            GET_BUCKETS_FAILURE]
    })
)

export const GET_BUCKET_FILES_REQUEST = '@@datasources/GET_BUCKET_FILES_REQUEST'
export const GET_BUCKET_FILES_SUCCESS = '@@datasources/GET_BUCKET_FILES_SUCCESS'
export const GET_BUCKET_FILES_FAILURE = '@@datasources/GET_BUCKET_FILES_FAILURE'
export const getBucketFiles = (bucket, filter = 'csv') => (
    get({
        displayName: 'get bucket files',
        endpoint: `${bucket}/${filter}`,
        types: [
            GET_BUCKET_FILES_REQUEST, 
            GET_BUCKET_FILES_SUCCESS, 
            GET_BUCKET_FILES_FAILURE]
    })
)

export const GET_BUCKET_FILE_DETAILS_REQUEST = '@@datasources/GET_BUCKET_FILE_DETAILS_REQUEST'
export const GET_BUCKET_FILE_DETAILS_SUCCESS = '@@datasources/GET_BUCKET_FILE_DETAILS_SUCCESS'
export const GET_BUCKET_FILE_DETAILS_FAILURE = '@@datasources/GET_BUCKET_FILE_DETAILS_FAILURE'
export const getFileDefinition = (filename) => (
    get({
        displayName: 'get file definition',
        endpoint: `${filename}`,
        types: [
            GET_BUCKET_FILE_DETAILS_REQUEST, 
            GET_BUCKET_FILE_DETAILS_SUCCESS, 
            GET_BUCKET_FILE_DETAILS_FAILURE]
    })
)

export const CREATE_DATASOURCE_REQUEST = '@@datasources/CREATE_DATASOURCE_REQUEST'
export const CREATE_DATASOURCE_SUCCESS = '@@datasources/CREATE_DATASOURCE_SUCCESS'
export const CREATE_DATASOURCE_FAILURE = '@@datasources/CREATE_DATASOURCE_FAILURE'
export const createLinkedDatasoureFromBucketFile = (endpoint, name, fileName, columns, selectedColumns) => (
    post({
        displayName: 'create linked datasource from bucket',
        endpoint: endpoint,
        types: [
            CREATE_DATASOURCE_REQUEST, 
            CREATE_DATASOURCE_SUCCESS, 
            CREATE_DATASOURCE_FAILURE],
        body: JSON.stringify({
            name:name,
            fileName: fileName,
            columns : columns,
            selectedColumns : selectedColumns,
            type : 'LinkedStorage',
        })
    })
)

export const createBigQueryDatasoure = (endpoint, name, tableName, tableType) => (
    post({
        displayName: 'create Big Query datasource',
        endpoint: endpoint,
        types: [
            CREATE_DATASOURCE_REQUEST, 
            CREATE_DATASOURCE_SUCCESS, 
            CREATE_DATASOURCE_FAILURE],
        body: JSON.stringify({
            name:name,
            tableName: tableName,
            tableType : tableType, 
            type : 'BigQuery',
        })
    })
)



// WEBPACK FOOTER //
// ./src/App/Admin/Datasources/actions.js